import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FeedBadge } from './FeedBadge';
import { formatRelativeTime } from '../../hooks/use-relative-time';
import styles from './EntityFeedCard.module.css';

type EntityFeedCardProps = {
  readonly entityId: string;
  readonly entityName: string;
  readonly tier: string;
  readonly substrate: string;
  readonly values: ReadonlyArray<string>;
  readonly timestamp: string;
};

const EntityFeedCard = ({ entityId, entityName, tier, substrate, values, timestamp }: EntityFeedCardProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <div
      className={styles.card}
      onClick={(): void => { void navigate(`/entity/${entityId}`); }}
      role="link"
      tabIndex={0}
      data-testid="entity-card"
    >
      <FeedBadge type="entity" />
      <div className={styles.headline}>{entityName} <span className={styles.joinedText}>joined the network</span></div>
      <div className={styles.meta}>
        <span>{tier}</span>
        <span className={styles.sep}>·</span>
        <span>{substrate}</span>
        {values.length > 0 ? (
          <>
            <span className={styles.sep}>·</span>
            <span>{values.slice(0, 3).join(', ')}</span>
          </>
        ) : null}
        <span className={styles.sep}>·</span>
        <span>{formatRelativeTime(timestamp)}</span>
      </div>
    </div>
  );
};

export { EntityFeedCard };
